(() => {
  if (window.rorilioCartVariants) return;
  window.rorilioCartVariants = true;
  let busy = false;
  const timerKey='rorilio-cart-deadline-v1';
  let fallbackDeadline=0;
  function tickTimer() {
    const drawer=document.querySelector('cart-drawer.active');
    const node=drawer?.querySelector('[data-rr-countdown]');
    if (!node) return;
    let deadline=fallbackDeadline;
    try {deadline=Number(sessionStorage.getItem(timerKey))||deadline;} catch(_) {}
    if (!deadline) {deadline=Date.now()+7*60*1000;fallbackDeadline=deadline;try {sessionStorage.setItem(timerKey,String(deadline));} catch(_) {}}
    const seconds=Math.max(0,Math.ceil((deadline-Date.now())/1000));
    const value=String(Math.floor(seconds/60)).padStart(2,'0')+':'+String(seconds%60).padStart(2,'0');
    if(node.textContent!==value) node.textContent=value;
    if (!seconds) {node.parentElement.hidden=true;}
  }
  setInterval(tickTimer,1000);
  new MutationObserver(tickTimer).observe(document.documentElement,{subtree:true,childList:true,attributes:true,attributeFilter:['class']});
  const root = () => window.Shopify?.routes?.root || '/';
  async function readCart() {
    const response = await fetch(root() + 'cart.js', {cache:'no-store'});
    if (!response.ok) throw new Error('No se pudo consultar el carrito. Inténtalo de nuevo.');
    return response.json();
  }
  function render(cart) {
    if (!cart.sections?.['cart-drawer'] || !cart.sections?.['cart-icon-bubble']) return false;
    document.querySelector('cart-drawer').renderContents(cart);
    if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate,{source:'cart-items',cartData:cart});
    return true;
  }
  async function refresh() {
    const url = new URL(location.href); url.searchParams.set('sections','cart-drawer,cart-icon-bubble');
    const response = await fetch(url,{cache:'no-store'});
    if (!response.ok) return false;
    return render({sections:await response.json()});
  }
  // Native Shopify bundles contain real unit variants; ordered tones select their composition.
  const lipProduct = 15427793977665;
  const toneNames = ['Cocoa Nude','Sweet Strawberry'];
  const propsKey = p => JSON.stringify(Object.entries(p||{}).sort(([a],[b])=>a.localeCompare(b)));
  const sameLine = (a,b) => a && b && a.key===b.key && a.quantity===b.quantity && a.variant_id===b.variant_id && propsKey(a.properties)===propsKey(b.properties) && !a.selling_plan_allocation;
  async function lipPost(endpoint, body) {
    const response=await fetch(root()+endpoint,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
    const value=await response.json();
    if (!response.ok || value.status) {const error=new Error(value.description||'No se pudo actualizar el pack.');error.definite=true;throw error;}
    return value;
  }
  const lipSections = () => ({sections:['cart-drawer','cart-icon-bubble'],sections_url:location.pathname});
  document.addEventListener('change', async event => {
    const select=event.target.closest?.('.rr-cart-lip-control');
    if (!select) return;
    event.stopImmediatePropagation();
    const wrapper=select.closest('[data-rr-lip-key]');
    const drawer=document.querySelector('cart-drawer');
    if (busy || document.querySelector('.cart__items--disabled')) {await refresh();return;}
    drawer.querySelector('.rr-variant-error')?.remove();
    const data=JSON.parse(wrapper.querySelector('[data-rr-lip-variants]').textContent);
    const units=Number(wrapper.dataset.lipUnits);
    const wrappers=[...drawer.querySelectorAll('[data-rr-lip-key]')].filter(w=>w.dataset.rrLipKey===wrapper.dataset.rrLipKey);
    const tones=wrappers.flatMap(w=>[...w.querySelectorAll('[data-lip-tone]')]).sort((a,b)=>Number(a.dataset.lipTone)-Number(b.dataset.lipTone)).map(s=>s.value);
    if(tones.length!==units){await refresh();return;}
    const variant=data.variants.find(v=>v.units===units && v.cocoa===tones.filter(t=>t==='Cocoa Nude').length);
    const showError=message=>{const node=document.createElement('p');node.className='rr-variant-error';node.setAttribute('role','alert');node.textContent=message;document.querySelector('#CartDrawer-CartErrors')?.append(node);};
    if(data.product!==lipProduct || ![1,2,4].includes(units) || tones.some(t=>!toneNames.includes(t)) || !variant?.available){await refresh();showError('Esta combinación no está disponible. Elige otros tonos.');return;}
    busy=true;drawer.setAttribute('aria-busy','true');
    const controls=[...drawer.querySelectorAll('input,select,button:not(.drawer__close)')].map(el=>[el,el.disabled]);controls.forEach(([el])=>el.disabled=true);
    let source, targetBefore=0, targetProps, addConfirmed=false, changed=false;
    const matchTarget = i=>i.product_id===lipProduct && i.variant_id===variant.id && propsKey(i.properties)===propsKey(targetProps) && !i.selling_plan_allocation;
    try {
      const cart=await readCart();source=cart.items.find(i=>i.key===wrapper.dataset.rrLipKey);
      if(!source || source.product_id!==lipProduct || source.selling_plan_allocation) throw new Error('El carrito ha cambiado. Vuelve a elegir tu pack.');
      targetProps={...(source.properties||{})};for(let n=1;n<=4;n++) delete targetProps['Tono '+n];tones.forEach((tone,n)=>targetProps['Tono '+(n+1)]=tone);
      if(source.variant_id===variant.id){
        if(propsKey(source.properties)===propsKey(targetProps)){await refresh();return;}
        changed=true;
        const updated=await lipPost('cart/change.js',{id:source.key,quantity:source.quantity,properties:targetProps,...lipSections()});
        if(!render(updated) && !await refresh()) location.reload();return;
      }
      targetBefore=cart.items.filter(matchTarget).reduce((n,i)=>n+i.quantity,0);
      changed=true;
      try {await lipPost('cart/add.js',{items:[{id:variant.id,quantity:source.quantity,properties:targetProps}],...lipSections()});}
      catch(error){if(error.definite) throw error; /* An uncertain add is reconciled, never repeated. */}
      const afterAdd=await readCart();const target=afterAdd.items.find(matchTarget);const currentSource=afterAdd.items.find(i=>i.key===source.key);
      addConfirmed=!!target && target.quantity===targetBefore+source.quantity;
      if(!addConfirmed || !sameLine(source,currentSource)) throw new Error('El carrito cambió durante la selección. Revísalo antes de continuar.');
      let updated;
      try {updated=await lipPost('cart/change.js',{id:source.key,quantity:0,...lipSections()});}
      catch(error){
        const reconciled=await readCart();
        if(reconciled.items.some(i=>i.key===source.key) || reconciled.items.filter(matchTarget).reduce((n,i)=>n+i.quantity,0)!==targetBefore+source.quantity) throw error;
        updated=reconciled;
      }
      addConfirmed=false;
      if(!render(updated) && !await refresh()) location.reload();
    } catch(error) {
      // Roll back only the exact newly added quantity, while the original line is unchanged.
      let recovery='';
      if(addConfirmed && source){try{const now=await readCart();const old=now.items.find(i=>i.key===source.key);const target=now.items.find(matchTarget);if(sameLine(source,old) && target?.quantity===targetBefore+source.quantity){await lipPost('cart/change.js',{id:target.key,quantity:targetBefore,...lipSections()});}else recovery=' Revisa las cantidades del carrito antes de volver a intentarlo.';}catch(_){recovery=' Revisa las cantidades del carrito antes de volver a intentarlo.';}}
      if(changed){try{await refresh();}catch(_){recovery=' Recarga el carrito antes de volver a intentarlo.';}}else{try{await refresh();}catch(_){}}
      showError((error.message||'No se pudo actualizar el pack.')+recovery);
    } finally {controls.forEach(([el,disabled])=>el.disabled=disabled);drawer.removeAttribute('aria-busy');busy=false;}
  },true);
  // Rímel Blushe, ligne de tubes : changer une couleur = mise à jour de la propriété Color/Colores de la ligne (même produit, même quantité).
  document.addEventListener('change', async event => {
    const select=event.target.closest?.('.rr-cart-tubo-control');
    if (!select) return;
    event.stopImmediatePropagation();
    const wrapper=select.closest('[data-rr-tubo-key]');const key=wrapper.dataset.rrTuboKey;
    const scope=select.closest('cart-drawer')||select.closest('cart-items')||document;
    const inDrawer=scope.tagName==='CART-DRAWER';
    const done=async updated=>{if(!inDrawer){location.reload();return;} if(!(updated&&render(updated)) && !await refresh()) location.reload();};
    if (busy) {await done();return;}
    busy=true;scope.setAttribute('aria-busy','true');
    try {
      const source=(await readCart()).items.find(i=>i.key===key);
      if(!source){await done();return;}
      const colors=[...wrapper.querySelectorAll('.rr-cart-tubo-control')].map(s=>s.value);
      const props={...(source.properties||{})};delete props.Color;delete props.Colores;props[colors.length>1?'Colores':'Color']=colors.join(', ');
      await done(await lipPost('cart/change.js',{id:source.key,quantity:source.quantity,properties:props,...lipSections()}));
    } catch(error) {
      try{if(inDrawer) await refresh(); else location.reload();}catch(_){}
    } finally {scope.removeAttribute('aria-busy');busy=false;}
  },true);
  // Rímel Blushe : couleur par tube modifiable (tiroir et page panier). Même combinaison = propriétés seules ; sinon nouvelle variante puis retrait de l'ancienne ligne.
  const rimelColors=['Negro','Café','Saúco'];
  const mixCounts=mix=>{const c={};String(mix||'').split(' + ').forEach(p=>{const [n,...col]=p.split(' ');c[col.join(' ')]=(c[col.join(' ')]||0)+Number(n);});return c;};
  const sameCounts=(a,b)=>rimelColors.every(k=>(a[k]||0)===(b[k]||0));
  document.addEventListener('change', async event => {
    const select=event.target.closest?.('.rr-cart-rimel-control');
    if (!select) return;
    event.stopImmediatePropagation();
    const wrapper=select.closest('[data-rr-rimel-key]');const key=wrapper.dataset.rrRimelKey;
    const scope=select.closest('cart-drawer')||select.closest('cart-items')||document;
    const inDrawer=scope.tagName==='CART-DRAWER';const drawer=document.querySelector('cart-drawer');
    const showError=message=>{const node=document.createElement('p');node.className='rr-variant-error';node.setAttribute('role','alert');node.textContent=message;(scope.querySelector('#CartDrawer-CartErrors')||scope.querySelector('#cart-errors')||wrapper).append(node);};
    const done=async updated=>{if(!inDrawer){location.reload();return;} if(!(updated&&render(updated)) && !await refresh()) location.reload();};
    if (busy) {await done();return;}
    scope.querySelector('.rr-variant-error')?.remove();
    const data=JSON.parse(wrapper.querySelector('[data-rr-rimel-variants]').textContent);
    const units=Number(wrapper.dataset.rimelUnits);
    const tones=[...scope.querySelectorAll('[data-rr-rimel-key]')].filter(w=>w.dataset.rrRimelKey===key).flatMap(w=>[...w.querySelectorAll('[data-rimel-tube]')]).sort((a,b)=>Number(a.dataset.rimelTube)-Number(b.dataset.rimelTube)).map(s=>s.value);
    if (tones.length!==units || tones.some(t=>!rimelColors.includes(t))) {await done();return;}
    const counts={};tones.forEach(t=>counts[t]=(counts[t]||0)+1);
    const variant=data.variants.find(v=>v.units===units && sameCounts(mixCounts(v.mix),counts));
    if (!variant?.available) {await done();showError('Esta combinación no está disponible. Elige otros colores.');return;}
    busy=true;scope.setAttribute('aria-busy','true');
    const controls=[...scope.querySelectorAll('input,select,button:not(.drawer__close)')].map(el=>[el,el.disabled]);controls.forEach(([el])=>el.disabled=true);
    let source,targetBefore=0,targetProps,addConfirmed=false;
    const matchTarget=i=>i.variant_id===variant.id && propsKey(i.properties)===propsKey(targetProps) && !i.selling_plan_allocation;
    try {
      const cart=await readCart();source=cart.items.find(i=>i.key===key);
      if(!source || source.product_id!==data.product || source.selling_plan_allocation) throw new Error('El carrito ha cambiado. Vuelve a elegir tus colores.');
      targetProps={...(source.properties||{})};for(let n=1;n<=4;n++) delete targetProps['Tubo '+n];tones.forEach((t,n)=>targetProps['Tubo '+(n+1)]=t);
      if(source.variant_id===variant.id){
        if(propsKey(source.properties)===propsKey(targetProps)){await done();return;}
        await done(await lipPost('cart/change.js',{id:source.key,quantity:source.quantity,properties:targetProps,...lipSections()}));return;
      }
      targetBefore=cart.items.filter(matchTarget).reduce((n,i)=>n+i.quantity,0);
      try {await lipPost('cart/add.js',{items:[{id:variant.id,quantity:source.quantity,properties:targetProps}]});}
      catch(error){if(error.definite) throw error;}
      // Une remise automatique peut changer la clé de ligne : l'ancienne ligne est retrouvée par variante + couleurs.
      const matchSource=i=>i.variant_id===source.variant_id && propsKey(i.properties)===propsKey(source.properties) && !i.selling_plan_allocation;
      const afterAdd=await readCart();const target=afterAdd.items.find(matchTarget);const current=afterAdd.items.find(matchSource);
      addConfirmed=!!target && target.quantity===targetBefore+source.quantity;
      if(!addConfirmed || !current || current.quantity!==source.quantity) throw new Error('El carrito cambió durante la selección. Revísalo antes de continuar.');
      const updated=await lipPost('cart/change.js',{id:current.key,quantity:0,...lipSections()});
      addConfirmed=false;await done(updated);
    } catch(error) {
      let recovery='';
      if(addConfirmed && source){try{const now=await readCart();const target=now.items.find(matchTarget);const old=now.items.find(i=>i.variant_id===source.variant_id && propsKey(i.properties)===propsKey(source.properties));if(old?.quantity===source.quantity && target?.quantity===targetBefore+source.quantity){await lipPost('cart/change.js',{id:target.key,quantity:targetBefore});}else recovery=' Revisa las cantidades del carrito.';}catch(_){recovery=' Revisa las cantidades del carrito.';}}
      try{if(inDrawer) await refresh();}catch(_){}
      showError((error.message||'No se pudo actualizar el pack.')+recovery);
    } finally {controls.forEach(([el,disabled])=>el.disabled=disabled);scope.removeAttribute('aria-busy');busy=false;}
  },true);
  document.addEventListener('change', async event => {
    const select = event.target.closest?.('.rr-cart-variant');
    if (!select) return;
    event.stopImmediatePropagation();
    const wrapper = select.closest('[data-rr-key]');
    const data = JSON.parse(wrapper.querySelector('[data-rr-variants]').textContent);
    const oldValue = data.current[Number(select.dataset.optionIndex)];
    if (busy || document.querySelector('.cart__items--disabled')) {select.value=oldValue;return;}
    const options=[...data.current]; options[Number(select.dataset.optionIndex)]=select.value;
    const variant=data.variants.find(v=>v.options.every((o,i)=>o===options[i]));
    const drawer=document.querySelector('cart-drawer');
    drawer.querySelector('.rr-variant-error')?.remove();
    function showError(message) {
      const node=document.createElement('p');node.className='rr-variant-error';node.setAttribute('role','alert');node.textContent=message;
      document.querySelector('#CartDrawer-CartErrors')?.append(node);
    }
    if (!variant?.available) {select.value=oldValue;showError('Esta combinación no está disponible. Elige otro tono.');return;}
    busy=true;drawer.setAttribute('aria-busy','true');
    const controls=[...drawer.querySelectorAll('input,select,button:not(.drawer__close)')].map(el=>[el,el.disabled]);
    controls.forEach(([el])=>el.disabled=true);
    let attempted=false;
    try {
      const cart=await readCart();const line=cart.items.find(i=>i.key===wrapper.dataset.rrKey);
      if (!line) throw new Error('El carrito ha cambiado. Vuelve a elegir tu tono.');
      if (line.variant_id===variant.id) return;
      if (Object.keys(line.properties||{}).length || line.selling_plan_allocation) throw new Error('Actualiza esta selección desde la página del producto.');
      const target=cart.items.find(i=>i.variant_id===variant.id && !Object.keys(i.properties||{}).length && !i.selling_plan_allocation);
      const updates={[line.key]:0,[target?.key||variant.id]:line.quantity+(target?.quantity||0)};
      attempted=true;
      const response=await fetch(root()+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates,sections:['cart-drawer','cart-icon-bubble'],sections_url:location.pathname})});
      const updated=await response.json();
      if (!response.ok || updated.status) throw new Error(updated.description||'No se pudo cambiar el tono. Inténtalo de nuevo.');
      if ((line.product_id===15432373076289||line.product_id===15434871275841) && !select.closest('cart-drawer')) location.reload(); else if (!render(updated) && !await refresh()) location.reload();
    } catch(error) {
      select.value=oldValue;
      if (attempted) {try {await refresh();} catch(_) {}}
      showError(error.message||'No se pudo actualizar el carrito. Inténtalo de nuevo.');
    } finally {
      controls.forEach(([el,disabled])=>el.disabled=disabled);
      drawer.removeAttribute('aria-busy');busy=false;
    }
  },true);
})();
